const ProductDetailsShimmer = () => {
  return (
    <div className="bg-gray-100 overflow-hidden animate-pulse">
      <div className="container mx-auto flex flex-col md:flex-row p-4 gap-4 md:mt-5 mt-2">
        {/* LEFT */}
        <div className="w-full md:w-1/2">
          <div className="w-full md:h-[600px] h-[400px] bg-gray-200 rounded-xl mb-4"></div>

          <div className="flex gap-2 overflow-hidden">
            {[...Array(5)].map((_, idx) => (
              <div
                key={idx}
                className="w-20 h-20 bg-gray-200 rounded-md flex-shrink-0"
              />
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="w-full md:w-1/2 p-4">
          <div className="h-8 w-3/4 bg-gray-200 rounded mb-3"></div>

          <div className="h-5 w-1/2 bg-gray-200 rounded mb-4"></div>

          <div className="flex gap-3 items-center mb-5">
            <div className="h-6 w-20 bg-gray-200 rounded"></div>
            <div className="h-6 w-24 bg-gray-200 rounded"></div>
            <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
          </div>

          <div className="space-y-2 mb-5">
            <div className="h-4 w-full bg-gray-200 rounded"></div>
            <div className="h-4 w-[90%] bg-gray-200 rounded"></div>
            <div className="h-4 w-[70%] bg-gray-200 rounded"></div>
          </div>

          <div className="mb-5">
            <div className="h-5 w-32 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-full bg-gray-200 rounded"></div>
          </div>

          <div className="mb-5">
            <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
            <div className="h-10 w-32 bg-gray-200 rounded"></div>
          </div>

          <div className="flex gap-2 mb-4">
            <div className="h-12 flex-1 bg-gray-200 rounded"></div>
            <div className="h-12 flex-[2] bg-gray-200 rounded"></div>
          </div>

          <div className="flex gap-2 mb-5">
            <div className="h-12 flex-1 bg-gray-200 rounded"></div>
            <div className="h-12 flex-[2] bg-gray-200 rounded"></div>
          </div>

          <div className="w-full h-28 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* DESCRIPTION */}
      <div className="container mx-auto px-4 pb-6">
        <div className="h-6 w-40 bg-gray-200 rounded mb-4"></div>

        <div className="space-y-2">
          <div className="h-4 w-full bg-gray-200 rounded"></div>
          <div className="h-4 w-[95%] bg-gray-200 rounded"></div>
          <div className="h-4 w-[80%] bg-gray-200 rounded"></div>
          <div className="h-4 w-[90%] bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* RELATED PRODUCTS */}
      <div className="container mx-auto px-4 pb-10">
        <div className="h-7 w-52 bg-gray-200 rounded mb-5"></div>

        <div className="flex gap-5 overflow-hidden">
          {[...Array(4)].map((_, idx) => (
            <div key={idx} className="flex-shrink-0 md:w-[240px] w-[47%]">
              <div className="aspect-[315/460] w-full bg-gray-200 rounded-xl mb-3"></div>

              <div className="h-4 w-3/4 bg-gray-200 rounded mb-2"></div>

              <div className="h-4 w-1/2 bg-gray-200 rounded mb-3"></div>

              <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsShimmer;
